<header class="header">
    <div class="header-left">
        <img src="assets/img/logo.png" alt="Logo Órgano Judicial" class="logo">

    </div>
    <!--    <div class="header-right">
        <i class="fas fa-user-circle me"></i>
        <span class="org-name">{{Usuario.TypeCourt}}</span>
        <a class="btn txt-oscuro" href="javascript:void(0);"  (click)="logout()"><span title="Cerrar sesión"
                class="fas fa-sign-out-alt"></span></a>
    </div> -->
    <div class="header-right">
        <div class="row">
            <div class="row justify-content-end">
                <span class="col-12 col-sm-auto org-name"><i class="fas fa-landmark"></i></span>
                <span class="col-12 col-sm-auto org-name">{{Usuario.TypeCourt}}</span>
            </div>
            <div class="row justify-content-end">
                <span class="col-12 col-sm-auto org-name"><i class="fas fa-user-circle me"></i></span>
                <span class="col-12 col-sm-auto org-name">({{Usuario.courtAux}}) {{Usuario.nameCourtAux}}</span>
            </div>
        </div>
        <a class="btn txt-oscuro" href="javascript:void(0);"  (click)="logout()"><span title="Cerrar sesión"
                class="fas fa-sign-out-alt"></span></a>

    </div>

</header>
@if(loading)
{
<div class="loading-overlay">
    <div class="loading-indicator">Cargando autoridades...</div>
</div>
}

<div class="container-fluid mt-5">
    <!-- Nav Tabs -->
    <ul class="nav nav-tabs" role="tablist">
        @for (tab of ItemsTabs; track tab.nombre) {
        @if (tab.visible) {
        <li class="nav-item">
            <button class="nav-link" [class.active]="activeTab() === tab.nombre" (click)="setTab(tab.nombre)">
                @if(tab.nombre === 'Supervisión') {
                <i class="fas fa-eye"></i>
                } @else if(tab.nombre === 'Representación') {
                <i class="fas fa-user"></i>
                }
                {{ tab.nombre | titlecase }}
            </button>
        </li>
        }
        }
    </ul>

    <!-- Tab Content -->
    <div class="tab-content p-3  border-top-0">
        @if (activeTab() === 'Supervisión') {
        <div class="lsOrganos p-4">
            <h3>Seleccione el órgano con el que desea ingresar: </h3>

            <h3>Búsqueda:</h3>
            <div class="mb-3">
                <input type="text" class="form-control mb-2 buscarShadow w50" [(ngModel)]="searchTermSup"
                    (input)="filterDataSup()">
            </div>

            <div class="table-container">
                <table>
                    <thead>
                        <tr>
                            <!-- <th scope="col">Id Órgano</th> -->
                            <th scope="col">Total notificaciones no notificadas</th>
                            <th scope="col">Nombre oficial</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (organo of paginatedDataSup; track organo.courtId) {
                        <tr>
                            <!-- <td [innerHTML]="organo.courtId | highlight:searchTerm"></td> -->
                            <td><span class="count"
                                    [ngClass]="{'active': organo.totalNotificacionesNoNotificadas > 0}">{{organo.totalNotificacionesNoNotificadas}}</span>
                            </td>
                            <td [innerHTML]="organo.courtName | highlight:searchTermSup"></td>
                            <td>
                                <button class="btn btn-icon btn-sm" (click)="seleccionaOrgano(organo)" type="submit">
                                    <i class="fas fa-arrow-alt-circle-right fa-2x" placement="left"
                                        ngbTooltip="Seleccionar órgano: {{organo.courtId}}"></i>
                                </button>
                            </td>
                        </tr>
                        }
                        @if(paginatedDataSup.length === 0){
                        <tr>
                            <td colspan="3">No hay información</td>
                        </tr>
                        }

                    </tbody>
                </table>

                <!-- Paginación -->

                <div class="pagination">
                    <span>
                       <b>Total de autoridades:</b> {{datosFiltradosSup.length}} <b>Núm. página:</b> {{currentPageSup}}  <b>Total registros por página:</b> {{paginatedDataSup.length}}
                    </span>
                      <!-- Primera página -->
                    <button
                        class="pagination-btn"
                        (click)="goToFirstPageSup()"
                        [disabled]="currentPageSup === 1"
                        ngbTooltip="Primera página">
                        <i class="fas fa-angle-double-left"></i>                        
                    </button>
                    <!-- Página anterior -->
                    <button 
                        class="pagination-btn" 
                        (click)="onPageChangeSup(currentPageSup - 1)"
                        [disabled]="currentPageSup === 1">
                        <i class="fas fa-chevron-left"></i>
                    </button>
                    <!-- Página siguiente -->
                    <button 
                        class="pagination-btn" 
                        (click)="onPageChangeSup (currentPageSup + 1)"
                        [disabled]="currentPageSup * pageSizeSup >= datosFiltradosSup.length">
                        <i class="fas fa-chevron-right"></i>
                    </button>
                     <!-- Última página -->
                    <button
                        class="pagination-btn"
                        (click)="goToLastPageSup()"
                        [disabled]="currentPageSup >= totalPagesSup"
                        ngbTooltip="Última página">
                        <i class="fas fa-angle-double-right"></i>
                    </button>
                </div>


            </div>
        </div>
        }
        @if (activeTab() === 'Representación') {
        <div class="lsOrganos p-4">
            <h3>Seleccione el órgano con el que desea ingresar: </h3>

            <h3>Búsqueda:</h3>
            <div class="mb-3">
                <input type="text" class="form-control mb-2 buscarShadow w50" [(ngModel)]="searchTerm"
                    (input)="filterData()">
            </div>

            <div class="table-container">
                <table>
                    <thead>
                        <tr>
                            <!-- <th scope="col">Id Órgano</th> -->
                            <th scope="col">Total notificaciones no notificadas</th>
                            <th scope="col">Nombre oficial</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (organo of paginatedData; track organo.courtId) {
                        <tr>
                            <!-- <td [innerHTML]="organo.courtId | highlight:searchTerm"></td> -->
                            <td><span class="count"
                                    [ngClass]="{'active': organo.totalNotificacionesNoNotificadas > 0}">{{organo.totalNotificacionesNoNotificadas}}</span>
                            </td>
                            <td [innerHTML]="organo.courtName | highlight:searchTerm"></td>
                            <td>
                                <button class="btn btn-icon btn-sm" (click)="seleccionaOrgano(organo)" type="submit">
                                    <i class="fas fa-arrow-alt-circle-right fa-2x" placement="left"
                                        ngbTooltip="Seleccionar órgano: {{organo.courtId}}"></i>
                                </button>
                            </td>
                        </tr>
                        }
                        @if(paginatedData.length === 0){
                        <tr>
                            <td colspan="3">No hay información</td>
                        </tr>
                        }

                    </tbody>
                </table>

                <!-- Paginación -->

                <div class="pagination">
                    <span></span>
                    <span>
                       <b>Total de autoridades:</b> {{datosFiltrados.length}} <b>Núm. página:</b> {{currentPage}}  <b>Total registros por página:</b> {{paginatedData.length}}
                    </span>
                     <!-- Primera página -->
                    <button
                        class="pagination-btn"
                        (click)="goToFirstPage()"
                        [disabled]="currentPage === 1"
                        ngbTooltip="Primera página">
                        <i class="fas fa-angle-double-left"></i>                        
                    </button>
                    <!-- Página anterior -->
                    <button 
                        class="pagination-btn" 
                        (click)="onPageChange(currentPage - 1)"
                        [disabled]="currentPage === 1"
                        ngbTooltip="Página anterior">
                        <i class="fas fa-chevron-left"></i>
                    </button>
                    <!-- Página siguiente -->
                    <button 
                        class="pagination-btn" 
                        (click)="onPageChange(currentPage + 1)"
                        [disabled]="currentPage * pageSize >= datosFiltrados.length"
                        ngbTooltip="Página siguiente">
                        <i class="fas fa-chevron-right"></i>
                    </button>
                     <!-- Última página -->
                    <button
                        class="pagination-btn"
                        (click)="goToLastPage()"
                        [disabled]="currentPage >= totalPages"
                        ngbTooltip="Última página">
                        <i class="fas fa-angle-double-right"></i>
                    </button>
                </div>


            </div>
        </div>
        }
    </div>
</div>